import { render } from "./IndexWo.vue?vue&type=template&id=6a4814ca"
import script from "./IndexWo.vue?vue&type=script&lang=js"
export * from "./IndexWo.vue?vue&type=script&lang=js"

import "./IndexWo.vue?vue&type=style&index=0&id=6a4814ca&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__